import { loadProgress } from "../state/progress";

const UNLOCK_KEY = "rl_tracker_unlocked_weeks_v1";

export function isDiaryAvailable() {
  try {
    const prog = loadProgress();
    const unlocked = JSON.parse(localStorage.getItem(UNLOCK_KEY) || "[]");
    const hasUnlocked4 = Array.isArray(unlocked) && unlocked.includes(4);
    const progressedTo4 = prog.currentWeek >= 4 || (prog.completedWeeks || []).includes(4) || (prog.skippedWeeks || []).includes(4);
    return hasUnlocked4 || progressedTo4;
  } catch {
    return false;
  }
}